/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.

Author: pulkit.shukla@edgeverve.com
 */


window.accessibilityBehaviours = window.accessibilityBehaviours || {};
accessibilityBehaviours.commonFunctions = {

    getTabIndex: function (index) {
        if (index === 0) {
            return 0;
        } else {
            return -1;
        }
    },

    getLabel: function (label) {
        return getLabel(label);
    },
    handleKeydown: function (e) {
        if (e.keyCode == 13 && e.currentTarget && e.currentTarget.click)
            e.currentTarget.click();
    },
    keydownAction: function (keyboardEvent) {

        var args = keyboardEvent.currentTarget.dataArgs.split(",");
        var length = Number(args[0]);
        var functionName = args[1];
        var nextIndex;

        // enter pressed!
        if (keyboardEvent.keyCode == 13) {
            this[functionName](keyboardEvent);
        } else if (keyboardEvent.keyCode === 37 || keyboardEvent.keyCode === 39 || keyboardEvent.keyCode === 38 || keyboardEvent.keyCode === 40) {


            var currentElement = keyboardEvent.currentTarget;
            currentElement.blur();

            var ddaId = currentElement.getAttribute("ddaId");
            var hyphenIndex = ddaId.indexOf("-");
            var idPrefix = ddaId.substring(0, hyphenIndex + 1);
            var currIndex = Number(ddaId.substring(hyphenIndex + 1));

            //right arrow pressed
            if (keyboardEvent.code === "ArrowRight" || keyboardEvent.code === "ArrowDown") {
                if (currIndex === length - 1) {
                    nextIndex = 0;
                } else {
                    nextIndex = currIndex + 1;
                }
            }

            //left arrow key pressed
            if (keyboardEvent.code === "ArrowLeft" || keyboardEvent.code === "ArrowUp") {
                if (currIndex === 0) {
                    nextIndex = length - 1;
                } else {
                    nextIndex = currIndex - 1;
                }
            }
			
			//focusing next element
			var query = '[ddaId="' + idPrefix + nextIndex + '"]';
			var nextElement = this.$$(query); //document.querySelector(query);
			if (nextElement)
				nextElement.focus();
        }
    }
};